<template>
  <div id="form">
    <div class="box-title">
      <p>{{ $t("message.strid1") }}</p>
    </div>
    <div class="form-box">
      <div
        class="item"
        v-for="(item, index) in list"
        :key="index"
        :class="[item.error ? 'error' : '', `item${index}`]"
      >
        <div
          v-if="item.key != 'else_country'"
          class="label"
          v-html="item.label"
        ></div>
        <div
          v-if="item.key == 'else_country' && item.isShow"
          class="label"
          v-html="item.label"
        ></div>
        <input
          :class="['input', item.type == 'code' ? 'code' : '']"
          @input="canNext(index)"
          @blur="checkData(index)"
          v-model="item.value"
          v-if="item.type == 'date'"
          type="date"
          required
        />
        <textarea
          v-if="
            (item.type == 'input' || item.type == 'code') &&
              item.key != 'else_country'
          "
          @input="canNext(index)"
          v-model="item.value"
          :class="['input', item.type == 'code' ? 'code' : '']"
          :rows="item.row ? item.row : 1"
          :placeholder="item.placeholder"
          :maxlength="500"
        ></textarea>
        <!-- 添加奖金池 -->
        <div class="price_pool" v-if="item.type == 'input_price_pool'">
          <textarea
            @blur="checkPricePool(index)"
            @input="canNext(index)"
            v-model="item.value"
            :class="['input', item.type == 'code' ? 'code' : '']"
            :rows="item.row ? item.row : 1"
            :placeholder="item.placeholder"
            :maxlength="500"
          ></textarea>
          <div class="error-tip" v-if="item.error" v-html="$t('message.strid73')" ></div>
        </div>
        <!-- 奖金池结束 -->
        <textarea
          v-if="
            (item.type == 'input' || item.type == 'code') &&
              item.key == 'else_country' &&
              item.isShow
          "
          @input="canNext(index)"
          v-model="item.value"
          :class="['input', item.type == 'code' ? 'code' : '']"
          :rows="item.row ? item.row : 1"
          :placeholder="item.placeholder"
        ></textarea>
        <div
          class="inputSelect"
          @click="handleSelect(index)"
          v-if="item.type == 'select'"
        >
          <span :class="['value', item.valueIndex != 100 ? 'active' : '']">{{
            item.value ? item.value : item.placeholder
          }}</span>
          <div :class="[showSelect == index ? 'up' : '', 'down']"></div>
          <ul v-show="showSelect == index" class="select-box">
            <li
              :data-index="i"
              @click="choseRegion(ele, i)"
              :class="item.valueIndex == i ? 'active' : ''"
              v-for="(ele, i) in item.options"
              :key="i"
            >
              {{ ele.name }}
            </li>
          </ul>
        </div>
        <Button
          v-if="!showTimer && item.type == 'code'"
          type="send"
          :noWrap="true"
          @click="sendCode"
          >{{ $t("message.strid23") }}</Button
        >
        <Button v-else-if="showTimer && item.type == 'code'" type="send"
          >{{ time }} S</Button
        >
      </div>
    </div>
    <div class="btn-group">
        <Button type="border" @click="backFn">{{ $t("message.strid21") }}</Button>
        <Button :type="check ? 'active' : 'default'" @click="jump('success')">{{
          $t("message.strid20")
        }}</Button>
    </div>
    <div class="blank"></div>
  </div>
</template>

<script>
import Button from "@/components/Button";
import { sendVc, submitForm, getConfig } from "@/proxy/index";
import { mapState } from "vuex";
import { isMobile } from "@/util/index";
export default {
  components: {
    Button
  },
  computed: {
    ...mapState(["_initdata"])
  },
  data() {
    return {
      region: { id: 0, name: "Select Region" },
      regionIndex: 100,
      showSelect: -1,
      buttonType: "default",
      list_clone: [],
      list: [
        {
          label: this.$t("message.strid2"), //邮箱
          placeholder: "",
          value: "",
          error: false,
          key: "email",
          type: "input"
        },
        {
          label: this.$t("message.strid3"), //验证码
          placeholder: "",
          value: "",
          error: false,
          key: "code",
          type: "code"
        },
        {
          label: this.$t("message.strid4"), //比赛名称
          placeholder: "",
          value: "",
          error: false,
          key: "event_name",
          type: "input"
        },
        {
          label: this.$t("message.strid5"), //比赛介绍  新
          placeholder: "",
          value: "",
          error: false,
          key: "contest_desc",
          type: "input"
        },
        {
          label: this.$t("message.strid6"), //比赛开始时间
          placeholder: "",
          value: "",
          error: false,
          key: "event_duration_start",
          type: "date"
        },
        {
          label: this.$t("message.strid7"), // 比赛结束时间
          placeholder: "",
          value: "",
          error: false,
          key: "event_duration_end",
          type: "date"
        },
        {
          label: this.$t("message.strid8"), //线上或线下   新
          placeholder: "",
          value: "",
          valueIndex: "",
          valueId: "",
          error: false,
          row: 3,
          key: "team_type",
          options: [
            { id: 1, name: this.$t("message.strid9") },
            { id: 2, name: this.$t("message.strid10") },
            { id: 3, name: this.$t("message.strid11") }
          ],
          type: "select"
        },
        {
          label: this.$t("message.strid51"), //国家/地区
          placeholder: this.$t("message.strid51"),
          value: "",
          valueIndex: "",
          valueId: "",
          error: false,
          row: 2,
          key: "cooper_event_country",
          type: "select",
          options: []
        },
        {
          label: this.$t("message.strid19"), //国家地区（其他） 新
          placeholder: "",
          value: "",
          error: false,
          key: "else_country",
          type: "input",
          isShow: false
        },
        {
          label: this.$t("message.strid16"),
          placeholder: "",
          value: "",
          error: false,
          key: "your_name",
          type: "input"
        },
        {
          label: this.$t("message.strid12"),
          placeholder: isMobile()
            ? this.$t("message.strid52")
            : this.$t("message.strid14"),
          value: "",
          error: false,
          key: "other_contact",
          type: "input"
        },
        {
          label: this.$t("message.strid53"), //新
          placeholder: "",
          value: "",
          valueIndex: "",
          error: false,
          key: "role",
          type: "select",
          valueId: "",
          options: [
            { id: 1, name: this.$t("message.strid17") },
            { id: 2, name: this.$t("message.strid18") },
            { id: 3, name: this.$t("message.strid70") }
          ]
        },
        {
          label: this.$t("message.strid72"), //奖金池
          placeholder: "",
          value: "",
          error: false,
          key: "price_pool",
          type: "input_price_pool"
        },
      ],
      check: false,
      timeout: null,
      time: 120,
      showTimer: false,
      timer: null,
      errIndex: 0
    };
  },
  watch: {
    _initdata: {
      immediate: true, // 立即执行
      handler(newVal) {
        this.list.forEach(element => {
          if (element.key == "cooper_event_country") {
            element.options = [
              {
                id: 44,
                name: this.$t("message.strid54"),
                sort: 11,
                bj_created_at: "",
                bj_updated_at: ""
              },
              {
                id: 2,
                name: this.$t("message.strid55"),
                sort: 10,
                bj_created_at: "",
                bj_updated_at: ""
              },
              {
                id: 11,
                name: this.$t("message.strid56"),
                sort: 9,
                bj_created_at: "",
                bj_updated_at: ""
              },
              {
                id: 26,
                name: this.$t("message.strid57"),
                sort: 8,
                bj_created_at: "",
                bj_updated_at: ""
              },
              {
                id: 14,
                name: this.$t("message.strid58"),
                sort: 8,
                bj_created_at: "",
                bj_updated_at: ""
              },
              {
                id: 35,
                name: this.$t("message.strid59"),
                sort: 7,
                bj_created_at: "",
                bj_updated_at: ""
              },
              {
                id: 32,
                name: this.$t("message.strid60"),
                sort: 6,
                bj_created_at: "",
                bj_updated_at: ""
              },
              {
                id: 41,
                name: this.$t("message.strid61"),
                sort: 3,
                bj_created_at: "",
                bj_updated_at: ""
              },
              {
                id: 38,
                name: this.$t("message.strid62"),
                sort: 3,
                bj_created_at: "",
                bj_updated_at: ""
              },
              {
                id: 29,
                name: this.$t("message.strid63"),
                sort: 3,
                bj_created_at: "",
                bj_updated_at: ""
              },
              {
                id: 23,
                name: this.$t("message.strid64"),
                sort: 3,
                bj_created_at: "",
                bj_updated_at: ""
              },
              {
                id: 20,
                name: this.$t("message.strid65"),
                sort: 3,
                bj_created_at: "",
                bj_updated_at: ""
              },
              {
                id: 17,
                name: this.$t("message.strid66"),
                sort: 3,
                bj_created_at: "",
                bj_updated_at: ""
              },
              {
                id: 8,
                name: this.$t("message.strid67"),
                sort: 2,
                bj_created_at: "",
                bj_updated_at: ""
              },
              {
                id: 5,
                name: this.$t("message.strid68"),
                sort: 1,
                bj_created_at: "",
                bj_updated_at: ""
              }
            ];
          }
        });
      }
    }
  },
  methods: {
    handleSelect(d) {
      if (String(this.showSelect) && this.showSelect != d) {
        this.showSelect = d;
      } else if (String(this.showSelect) && this.showSelect == d) {
        this.showSelect = -1;
      } else {
        this.showSelect = -1;
      }
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
    },
    choseRegion(ele, i) {
      let listIndex = this.showSelect;
      this.list[listIndex].valueId = ele.id;
      this.list[listIndex].value = ele.name;
      this.list[listIndex].valueIndex = i;
      if (listIndex == 7 && ele.id == 5) {
        this.list[8].isShow = true;
        if (!this.list[8].value) {
          this.check = false;
          this.errIndex = i;
        }
      } else if (listIndex == 7 && ele.id != 5) {
        this.list[8].isShow = false;
        this.list[8].value = "";
      }
      this.canNext(listIndex);
    },
    jump(name) {
      for (let i = 0; i < this.list.length; i++) {
        if (!this.list[i].value) {
          if (
            this.list[i].key == "other_contact" ||
            this.list[i].key == "contest_desc"
          ) {
            this.list[i].error = false;
          } else {
            this.list[i].error = true;
          }
        } else if(this.list[i].key === "price_pool" && !(this.list[i].value >= 3000)){
          this.list[i].error = true;
        }
        else {
          this.list[i].error = false;
        }
      }
      if (this.check) {
        let info = {
          lang: localStorage.getItem("lang") || "en"
        };
        this.list.map(i => {
          info[i.key] = i.value;
        });
        let country_id = this.list.filter(
          item => item.key == "cooper_event_country"
        )[0].valueId;

        if(!(info["price_pool"] >= 3000)){
          alert("Invalid prize pool!")
          return
        }

        submitForm(
          this.list.find(e => e.key == "email").value,
          this.list.find(e => e.key == "code").value,
          JSON.stringify(info),
          country_id,
          // this.$route.query.c,
          // this.$route.query.t,
          2,
          this.formatDate(new Date())
        ).then(res => {
          if (res.data.code == 0) {
            if (this.$route.query.t == 2) {
              this.$router.push({ name, query: { t: 2 } });
            } else {
              this.$router.push({ name });
            }
          } else if (res.data.code == -20008) {
            alert(
              "Invalid verification code! Please re-enter verification code!"
            );
          } else {
            alert(`Service Error (${res.data.code})`);
          }
        });
      } else {
        // alert('Please complete the form')
        const dom = document.querySelector(`.item${this.errIndex}`);
        window.scrollTo({
          top: dom.offsetTop,
          behavior: "smooth"
        });
        console.log(dom.offsetTop);
      }
    },
    checkemail(value) {
      return /^[a-zA-Z0-9]+([._\\-]*[a-zA-Z0-9])*@([a-zA-Z0-9]+[-a-zA-Z0-9]*[a-zA-Z0-9]+.){1,63}[a-zA-Z0-9]+$/.test(
        value
      );
    },
    checkPricePool(index) {
      
      if (this.list[index].value >= 3000) {
        this.list[index].error = false;
        this.list[index].value = Number(this.list[index].value);
      } else {
        this.list[index].error = true;
        this.check = false;
        this.errIndex = index;
      }
    },
    backFn() {
      this.$router.go(-1);
    },
    setSession() {
      window.sessionStorage.setItem("form", JSON.stringify(this.list));
    },
    checkData(index) {
      if (!this.list[index].value) {
        if (
          this.list[index].key == "other_contact" ||
          this.list[index].key == "contest_desc"
        ) {
          this.list[index].error = false;
        } else {
          this.list[index].error = true;
        }
      } else {
        this.list[index].error = false;
      }
    },
    canNext(index) {
      if (this.timeout !== null) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.setSession();
        let country = this.list.filter(
          item => item.key == "cooper_event_country"
        )[0].valueId;

        if (this.list[index].key === "price_pool" && !(this.list[index].value >= 3000)) {
          this.check = false;
          this.errIndex = index;
          this.list[index].error = true;
          return
        }

        if (!this.list[index].value) {
          if (
            this.list[index].key == "other_contact" ||
            this.list[index].key == "contest_desc"
          ) {
            this.list[index].error = false;
          } else {
            this.list[index].error = true;
          }
        } else {
          this.list[index].error = false;
        }

        for (let i = 0; i < this.list.length; i++) {
          // 奖金池校验
          if (this.list[i].key === "price_pool") {
            if(this.list[i].value >= 3000){
              this.check = true
              this.list[i].error = false
            }else{
              this.check = false
              this.errIndex = i
              this.list[i].error = true
              break
            }
          }
          //如果是其他联系方式 或者是比赛介绍 跳过校验
          else if (!this.list[i].value) {
            if (
              this.list[i].key == "other_contact" ||
              this.list[i].key == "contest_desc"
            ) {
              this.check = true;
            } else if (this.list[i].key == "else_country" && country != 5) {
              this.check = true;
            } else {
              this.check = false;
              this.errIndex = i;
              break;
            }
          } else {
            this.check = true;
          }
        }
      }, 200);
    },
    sendCode() {
      const email = this.list.find(e => e.key == "email");
      if (!email.value || !this.checkemail(email.value)) {
        email.error = true;
        return false;
      }
      this.showTimer = true;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          this.time = 120;
          this.showTimer = false;
          clearInterval(this.timer);
        }
      }, 1000);
      sendVc(1, email.value).then(res => {
        if (res.data.code == 0) {
          alert(this.$t('message.strid71', { emails: email.value||'' }));
          // alert(
          //   `We've sent you an email with verification code to ${email.value}. Please check your mail and verify the code`
          //   );
        } else {
          alert(`Service Error (${res.data.code})`);
        }
      });
    }
  },
  created() {
    if (window.sessionStorage.getItem("enter") != 1) {
      window.sessionStorage.removeItem("form");
      this.$router.replace({ name: "law" });
    }
    const data = window.sessionStorage.getItem("form");
    if (data) {
      const datas = JSON.parse(data);
      datas.map((i, k) => {
        this.list[k].value = i.value;
        this.list[k].valueIndex = i.valueIndex;
        this.list[k].valueId = i.valueId;
        if (i.key == "cooper_event_country" && i.valueId == 5) {
          this.list[k + 1].isShow = true;
        }
      });
      let country = this.list.filter(
        item => item.key == "cooper_event_country"
      )[0].valueId;
      for (let i = 0; i < this.list.length; i++) {
        if (!this.list[i].value) {
          if (
            this.list[i].key == "other_contact" ||
            this.list[i].key == "contest_desc"
          ) {
            this.check = true;
          } else if (this.list[i].key == "else_country" && country != 5) {
            this.check = true;
          } else {
            this.check = false;
            this.errIndex = i;
            break;
          }
        } else if(this.list[i].key === "price_pool" && !(this.list[i].value >= 3000)){
          this.check = false;
          this.errIndex = i;
        } else {
          this.check = true;
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    if (this.timer) {
      clearInterval(this.timer);
    }
    next();
  }
};
</script>

<style lang="scss">
@media screen and (min-width: $mimViewWidth) {
  @import "@/assets/scss/views/form.scss";
}
@media screen and (max-width: $maxViewWidth) {
  @import "@/assets/scss/views/m/form.scss";
}
</style>
